import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { ring, unlockAudio } from "@/lib/push";

// Alerta de cliente esperando resposta no WhatsApp (pausa do bot).
export function WaAlerts() {
  const shown = useRef(new Set());
  useEffect(() => {
    const unlock = () => unlockAudio();
    document.addEventListener("pointerdown", unlock, { once: true });
    const check = () => api.get("/whatsapp/alerts").then((r) => r.data.forEach((a) => {
      if (shown.current.has(a.id)) return;
      shown.current.add(a.id);
      ring("liberacao");
      toast.warning(`WhatsApp: ${a.name} (+${a.phone}) está esperando resposta`, {
        id: `wa-${a.id}`, description: a.text, duration: Infinity,
        action: { label: "Ok", onClick: () => api.post(`/whatsapp/alerts/${a.id}/seen`).catch(() => {}) },
      });
    })).catch(() => {});
    check();
    const t = setInterval(check, 15000);
    return () => { clearInterval(t); document.removeEventListener("pointerdown", unlock); };
  }, []);
  return null;
}
